import { alpha, Stack, type StackProps, Typography } from '@mui/material';

const CardSection = ({
    color = 'white',
    title,
    description,
    icon,
    button,
    size = 'md',

    onClick,
    ...props
}: {
    color?: 'white' | 'gray';
    title: string;
    description: string;
    icon: React.ReactNode;
    button: React.ReactNode;
    size?: 'md' | 'lg';
    onClick?: () => void;
} & StackProps) => (
    <Stack
        {...props}
        onClick={onClick}
        sx={{
            borderRadius: 0.5,
            border: (t) => `1px solid ${alpha(t.palette.primary.main, 0.12)}`,
            background: color === 'gray' ? '#F5F5F5' : 'white',
            height: '100%',
            ...(onClick && {
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: 'primary.itemSelectedBackground',
                    borderColor: 'secondary.main',
                },
            }),
        }}
        p={3}
        direction='row'
        spacing={2}
    >
        <Stack>{icon}</Stack>
        <Stack spacing={2}>
            <Stack spacing={1}>
                <Typography variant={size === 'lg' ? 'h5' : 'h6'} color='primary'>
                    {title}
                </Typography>
                <Typography variant='body2' fontWeight='400' color='primary.mui.inactive'>
                    {description}
                </Typography>
            </Stack>
            {button}
        </Stack>
    </Stack>
);

export default CardSection;
